import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import {formatNumber} from '../../data/numberutils';
import { defaultTheme } from '../../data/themes';
import Icon from '../../components/icon';
import { showMessageBox } from '../../actions/modal';
import { getPhrase } from '../../data/phrases';

const EMPTY_MAP = Immutable.Map({});


const RowCount = styled.div`
	color: ${props => props.theme.color || defaultTheme.color};
	font-size: 14px;
	font-weight: 700;
	display: inline-block;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`;

export class RowCountMessage extends React.PureComponent {
	constructor() {
		super();
		this.onMouseDown = this.onMouseDown.bind(this);
	}

	async onMouseDown(e) {
		let maxRowsPerPage = await showMessageBox(getPhrase('rowsPerPage5to200'), {type: 'input', optional: true});
		if (!maxRowsPerPage) {
			return;
		}
		maxRowsPerPage = parseInt(maxRowsPerPage);
		if (isNaN(maxRowsPerPage)) {
			return;
		}
		this.setMaxRowsPerPage(maxRowsPerPage);
	}

	onPageRequested(firstRow, maxRowsPerPage) {
		if (this.props.onPageRequested) {
			maxRowsPerPage = maxRowsPerPage || this.props.pager.get('maxRowsPerPage');
			this.props.onPageRequested(firstRow, maxRowsPerPage);
		}
	}

	setMaxRowsPerPage(maxRowsPerPage) {
		let firstRow = this.props.pager.get('firstRow') || 1;
		if (maxRowsPerPage < 5) {
			maxRowsPerPage = 5;
		} else if (maxRowsPerPage > 200) {
			maxRowsPerPage = 200;
		}
		firstRow = Math.floor((firstRow - 1) / maxRowsPerPage) + 1;
		this.onPageRequested(firstRow, maxRowsPerPage);
		//this.onPageRequested(this.props.pager.get('maxRowsPerPage') * page + 1);
	}

	getText() {
		const pager = this.props.pager;
		if (!pager) {
			return null;
		}
		const minusValue = this.props.minus || 0;
		const firstRow = pager.get('firstRow');
		const totalCount = pager.get('totalCount') - minusValue;
		let displayedCount = pager.get('maxRowsPerPage');
		if ((firstRow + displayedCount) > totalCount) {
			displayedCount = totalCount - firstRow + 1;
		}
		if (totalCount === 0) {
			return getPhrase('noRecordsFound');// 'Nenalezeny žádné záznamy';
		} else if (totalCount <= displayedCount) {
			return getPhrase('displayingTotalCountRecords').replace('$totalCount', formatNumber(totalCount)); //'Zobrazeno ' + totalCount + ' záznamů';
		} else {
			return getPhrase('displayingDisplayedCountOutOfTotalCountRecords').replace('$totalCount', formatNumber(totalCount)).replace('$displayedCount', formatNumber(displayedCount));
			//return 'Zobrazeno ' + displayedCount + ' z ' + formatNumber(totalCount) + ' záznamů';
		}
	}

	render() {
		return (
			<RowCount
				onMouseDown={this.onMouseDown}
			>
				{this.getText()}
			</RowCount>
		);
	}
}

const EnumPager = styled.span`
	display: inline-block;
	padding: ${props => props.theme.enumPagerPadding || defaultTheme.enumPagerPadding};
	.icon {
		position: relative;
		top: -1px;
		cursor: pointer;
		padding: ${props => props.theme.enumPagerIconPadding || defaultTheme.enumPagerIconPadding};
		color: ${props => props.theme.enumPageColor || defaultTheme.enumPageColor};
		font-size: ${props => props.theme.enumPageFontSize || defaultTheme.enumPageFontSize};
		&:hover {
			color: ${props => props.theme.enumHoverPageColor || defaultTheme.enumHoverPageColor};
		}
	}
	.prevButtonText {
		font-size: ${props => props.theme.enumPagerPrevButtonTextSize};
		font-weight: ${props => props.theme.enumPagerPrevButtonFontWeight};
		margin: ${props => props.theme.enumPagerPrevButtonTextMargin};
	}
	.nextButtonText {
		font-size: ${props => props.theme.enumPagerNextButtonTextSize};
		font-weight: ${props => props.theme.enumPagerNextButtonFontWeight};
		margin: ${props => props.theme.enumPagerNextButtonTextMargin};
	}

`;

/*
		enumPageBorder: '2px solid #E4F1FD',
		enumPageBorderRadius: '4px',
		enumPageMargin: '8px',

		enumHoverTextDecoration: 'underline',
		enumSelectedPageBorder: '2px solid #297FCA',
*/
const EnumPage = styled.span`
	display: inline-block;
	margin: ${props => props.theme.enumPageMargin || defaultTheme.enumPageMargin};
	padding: ${props => props.theme.enumPagePadding || defaultTheme.enumPagePadding};
	color: ${props => props.theme.enumPageColor || defaultTheme.enumPageColor};
	font-size: ${props => props.theme.enumPageFontSize || defaultTheme.enumPageFontSize};
	font-weight: ${props => props.theme.enumPageFontWeight || defaultTheme.enumPageFontWeight};
	border: ${props => props.theme.enumPageBorder};
	border-radius: ${props => props.theme.enumPageBorderRadius};
	cursor: pointer;

	&.selected {
		color: ${props => props.theme.enumSelectedPageColor || defaultTheme.enumSelectedPageColor};
		font-size: ${props => props.theme.enumSelectedPageFontSize || defaultTheme.enumSelectedPageFontSize};
		font-weight: ${props => props.theme.enumSelectedPageFontWeight || defaultTheme.enumSelectedPageFontWeight};
		border: ${props => props.theme.enumSelectedPageBorder};
		cursor: default;
	}

	&:not(.selected):hover {
		color: ${props => props.theme.enumHoverPageColor || defaultTheme.enumHoverPageColor};
		font-size: ${props => props.theme.enumHoverPageFontSize || defaultTheme.enumHoverPageFontSize};
		font-weight: ${props => props.theme.enumHoverPageFontWeight || defaultTheme.enumHoverPageFontWeight};
		text-decoration: ${props => props.theme.enumHoverPageTextDecoration || defaultTheme.enumHoverPageTextDecoration};
	}

	&.prev, &.next {
		border: none;
	}
`;

const EnumPageGroup = styled.span`
	.customPagePicker {
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
`;

function getEnumPages(firstRow, maxRowsPerPage, totalCount, spread = 3) {
	if (!totalCount || totalCount < 0) {
		return null;
	}
	let currPage = Math.floor((firstRow - 1) / maxRowsPerPage);
	const minPage = 0;
	const maxPage = Math.floor((totalCount - 1) / maxRowsPerPage);
	if (minPage === maxPage) {
		return null;
	}
	let minMainPage = currPage - spread;
	let maxMainPage = currPage + spread;
	if (minMainPage < minPage) {
		maxMainPage = minPage + (spread * 2);
	}
	if (maxMainPage > maxPage) {
		minMainPage = maxPage - (spread * 2);
	}
	if (minMainPage < minPage) {
		minMainPage = minPage;
	}
	if (maxMainPage > maxPage) {
		maxMainPage = maxPage;
	}
	if (minMainPage === 1) {
		minMainPage = 0;
	}
	if (maxMainPage === (maxPage - 1)) {
		maxMainPage = maxPage;
	}
	let res = [];
	if (minMainPage > minPage) {
		res.push([minPage]);
	}
	let main = [];
	for (let i=minMainPage; i <= maxMainPage; i++) {
		main.push(i);
	}
	res.push(main);
	if (maxMainPage < maxPage) {
		res.push([maxPage]);
	}
	return {
		currentPage: currPage,
		hasPrev: currPage > minPage,
		hasNext: currPage < maxPage,
		minPage,
		maxPage,
		pages: res
	};
}

export class Pager extends React.PureComponent {
	constructor() {
		super();
		this.onCustomPageMouseDown = this.onCustomPageMouseDown.bind(this);
	}

	getSpread() {
		return this.props.spread || 3;
	}

	async onCustomPageMouseDown(e) {
		const pager = this.props.pager;
		const pageInfo = getEnumPages(pager.get('firstRow'), pager.get('maxRowsPerPage'), pager.get('totalCount'), this.getSpread());
		let reqPage = await showMessageBox(getPhrase('pageNumber'), {type: 'input', optional: true});
		if (!reqPage) {
			return;
		}
		reqPage = parseInt(reqPage);
		if (isNaN(reqPage)) {
			return;
		}
		reqPage--;
		if (reqPage < pageInfo.minPage) {
			reqPage = pageInfo.minPage;
		} else if (reqPage > pageInfo.maxPage) {
			reqPage = pageInfo.maxPage;
		}
		this.gotoPage(reqPage);
	}

	onPageRequested(firstRow, maxRowsPerPage) {
		if (this.props.onPageRequested) {
			maxRowsPerPage = maxRowsPerPage || this.props.pager.get('maxRowsPerPage');
			this.props.onPageRequested(firstRow, maxRowsPerPage);
		}
	}

	gotoPage(page) {
		this.onPageRequested(this.props.pager.get('maxRowsPerPage') * page + 1);
	}

	renderEnumPages(pager) {
		const firstRow = pager.get('firstRow');
		const maxRowsPerPage = pager.get('maxRowsPerPage');
		if (!firstRow && !maxRowsPerPage) {
			return null;
		}
		const pageInfo = getEnumPages(firstRow, maxRowsPerPage, pager.get('totalCount'), this.getSpread());
		if (!pageInfo) {
			return null;
		}
		const currPage = pageInfo.currentPage;
		const pages = pageInfo.pages;
		return (
			<EnumPager className="ps-enumPager">
				{
					pageInfo.hasPrev && (
						<EnumPage
							className="ps-enumPage prev"
							onMouseDown={e => {
								e.preventDefault();
								this.gotoPage(currPage - 1);
							}}
						>
							<Icon
								name="prev"
							/>
							{
								!!this.props.prevButtonText && (
									<span className="prevButtonText">{this.props.prevButtonText}</span>
								)
							}
						</EnumPage>
					)
				}
				{
					pages.map((group, groupIndex) => {
						return (
							<EnumPageGroup
								key={groupIndex}
								className="ps-enumPageGroup"
							>
								{
									groupIndex > 0 && (
										<span
											className="customPagePicker"
											onMouseDown={this.onCustomPageMouseDown}
										>
											...
										</span>
									)
								}
								{
									group.map(page => {
										return (
											<EnumPage
												key={page}
												className={'ps-enumPage' + (page === currPage ? ' selected' : '')}
												onMouseDown={e => {
													e.preventDefault();
													this.gotoPage(page);

												}}
											>
												{page + 1}
											</EnumPage>
										)
									})
								}
							</EnumPageGroup>
						);
					})
				}
				{
					pageInfo.hasNext && (
						<EnumPage
							className="ps-enumPage next"
							onMouseDown={e => {
								e.preventDefault();
								this.gotoPage(currPage + 1);
							}}
						>
							{
								!!this.props.nextButtonText && (
									<span className="nextButtonText">{this.props.nextButtonText}</span>
								)
							}
							<Icon
								name="next"
							/>
						</EnumPage>
					)
				}
			</EnumPager>
		)

	}

	render() {
		if (!this.props.pager) {
			return null;
		}
		return this.renderEnumPages(this.props.pager);
	}
}


